<template>
	<van-row class="">
		<Header></Header>
		<van-row class="Coursedetail w95">
			<van-row class='cobg'>
				<!-- <img src="" > -->
			</van-row>
			<van-row class='coname'>
				<p>2019年（下）国考教师资格证-考前押题刷题（幼儿）</p>
			</van-row>
			<van-row class='contxt'>
				<p>开班时间：2019.1.10~1.20</p>
			</van-row>
			<van-row class='conteacher'>
				<p style="margin: 0px 0px 0px 13px;color: #666;">咨询老师：
				 <span>X老师 138-8888-8888 </span>
				 <span>
					 X老师 139-9999-9999
				 </span>
				</p>
			</van-row>
			<van-row class='coline'></van-row>
			<van-row class='cobtn'>
				<p>2019.1.10开班</p>
				<p @click="buy()"><span>立即咨询</span></p>
			</van-row>
		</van-row>
		<van-row class='colist w95'>
			<div class="nav">
				<van-tabs  title-inactive-color='#666' title-active-color='#007CCF' background="#fafafa"
				 swipeable animated :ellipsis="false" >
					<van-tab title="课程详情" name='0'>
						<van-row style="margin-top: 10px;" class="list1">
							<p>
								看似简单会计考试的还是考虑去沃尔看见了雷克萨多了；打卡；立即打死了；的；拉到了；
								 看似简单会计考试的还是考虑去沃尔看见了雷克萨多了；打卡；立即打死了；的；拉到了； 
								 看似简单会计考试的还是考虑去沃尔看见了雷克萨多了；打卡；立即打死了；的；拉到了； 
							</p>
							<img src="../assets/home/bg4.png" alt="">
						</van-row>
					</van-tab>
					<van-tab title="环境展示" name='1'>
						<van-row style="margin-top: 10px;" class="list1">
						    <p>
								奥阿萨德ad爱仕达大所多术大师多撒多
								爱仕达多所阿萨德阿萨德阿萨德阿萨德阿萨德	阿萨德
							</p>
						</van-row>
					</van-tab>
					
				
				</van-tabs>
			</div>
		</van-row>
		<Fotter></Fotter>
	</van-row>
</template>

<script>
	import Vue from 'vue'
	import Header from "./Header.vue";
	import Fotter from "./Fotter.vue";
	import { Dialog } from 'vant';
	// 全局注册
	Vue.use(Dialog);
	export default {
		name: 'Coursedetail_Bot',
		components: {
			Header,
			Fotter,
		
		},
		data() {
			return {

			}

		},
		methods: {
        buy(){
			Dialog.confirm({
			  title: '咨询热线',
			  showCancelButton:false,
			  message: '400-996-2596'
			}).then(() => {
			  // on confirm
			}).catch(() => {
			  // on cancel
			});
		}
		}
	}
</script>

<style scoped>
	.Coursedetail {
		margin: 20px auto;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 4px 10px rgba(0, 124, 216, 0.1);
	}

	.cobg {
		width: 100%;
		height: 192px;
	}

	.cobg img {
		width: 100%;
		height: 100%;
	}

	.coname p {
		margin: 13px 13px 0px 13px;
		font-size: 15px;
		font-weight: 600;
		line-height: 23px;
		color: rgba(51, 51, 51, 1);
	}

	.contxt {
		height: 40px;
		line-height: 30px;
		font-size: 14px;
	}

	.contxt p {
	    color:  #FF5590;
		margin: 13px;
	}



	.coline {
		width: 95%;
		height: 0px;
		border: 1px solid rgba(204, 204, 204, 1);
		margin: 20px auto;
	}

	.cobtn {
		width: 100%;
		height: 50px;

		margin: 0px auto 20px auto;
		display: flex;

	}

	.cobtn p:nth-child(1) {
		flex: 1;
		margin: 13px;
		font-weight: 300;
		color: rgba(153, 153, 153, 1);
	}

	.cobtn p:nth-child(2) {
		width: 94px;
		margin-top: 13px;
	}

	.cobtn p:nth-child(2) span {
		background: rgba(0, 124, 207, 1);
		border-radius: 22px;
		padding: 9px 11px;
		color: #fff;
		line-height: 20px;
		font-weight: bold;
	}
	.colist{
		margin: 30px auto;
		background:rgba(255,255,255,1);
		box-shadow:0px 4px 10px rgba(0,124,216,0.1);
		border-radius:7px;

	}
	.list1 p{
		margin: 13px;
		line-height: 20px;
		color: #666;
		font-size: 14px;
	}
		.list1 img{
			width: 100%;
		}
		.colcourselist{
			width: 95%;
			height: 100px;
		
		}
		.col1{
			width: 60px;
		
		}
		.col1 p{
			width: 25px;
			height: 25px;
			background: #007CCF;
			border-radius: 100%;
			text-align: center;
			line-height: 25px;
			color: #fff;
		}
		.col2{
			flex: 1;
			
		}
		.col2 P:nth-child(1){
			color: #007CCF;
		}
		.tecol{
		
		}
		.tecol p:nth-child(1){
			width:100px;
			height: 83px;
			margin: 13px;
		}
		.tecol p:nth-child(1) img{
			width: 100%;
			height: 100%;
		}
		.tecol p:nth-child(2){
			flex: 1;
		
		}
		.tecol p:nth-child(2) span{
			display: block;
			margin: 13px;
		}
		.tecol p:nth-child(2) span:nth-child(1){
			font-size: 14px;
			color: #333;
			font-weight: bold;
		}
		.tecol p:nth-child(2) span:nth-child(2){
			color: #999;
		}
		.conteacher p span{
			margin-left: 10px;
		}
</style>



// WEBPACK FOOTER //
// src/components/Coursedetail_Bot.vue